export const iconFontAwesomeFilmVideoTowerBroadcast = (
	<i className="fa-solid fa-tower-broadcast"></i>
);
